import { signal } from '@preact/signals';

/** Where the teacher last clicked in classroom mode (F15). Each click gets its own ring. */
const dots = signal<Array<{ x: number; y: number; id: number }>>([]);
let next = 0;

export function pointAt(x: number, y: number) {
  const id = ++next;
  dots.value = [...dots.value.slice(-3), { x, y, id }];
  setTimeout(() => (dots.value = dots.value.filter((d) => d.id !== id)), 1300);
}

export function LaserPointer() {
  return (
    <>
      {dots.value.map((d) => (
        <span key={d.id} class="laser" style={{ left: `${d.x}px`, top: `${d.y}px` }} aria-hidden="true" data-testid="laser" />
      ))}
    </>
  );
}
